import { AlertStatus } from "./mockAlerts";

export interface EmailCampaign {
  id: string;
  category: string; // 'tous', 'citoyens', 'partis', 'ong', 'institutions'
  segment: string; // 'tous', 'H', 'F', ou nom de la région
  subject: string;
  body: string;
  attachmentDataUrl?: string;
  status: AlertStatus;
  scheduledFor?: string;
  createdAt: string;
}

const STORAGE_KEY = "kaynin_admin_emails";

export function loadEmails(): EmailCampaign[] {
  if (typeof window === "undefined") return [];
  const data = localStorage.getItem(STORAGE_KEY);
  if (data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error(e);
    }
  }
  return [];
}

export function saveEmails(emails: EmailCampaign[]) {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(emails));
    window.dispatchEvent(new CustomEvent("emailsChanged"));
  }
}

export function addEmail(email: Omit<EmailCampaign, "id" | "createdAt">) {
  const current = loadEmails();
  const newEmail: EmailCampaign = {
    ...email,
    id: `email-${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
    createdAt: new Date().toISOString()
  };
  current.unshift(newEmail);
  saveEmails(current);
  return newEmail;
}

export function updateEmail(id: string, updates: Partial<EmailCampaign>) {
  const current = loadEmails();
  const idx = current.findIndex(a => a.id === id);
  if (idx !== -1) {
    current[idx] = { ...current[idx], ...updates };
    saveEmails(current);
  }
}

export function deleteEmail(id: string) {
  const current = loadEmails();
  saveEmails(current.filter(a => a.id !== id));
}
